import type { JSX } from 'react'

export const Ghost500Icon = (): JSX.Element => (
  <use href='#ghost500' height='100%' width='100%' />
)
